import dayjs from 'dayjs';
import { useMessageGetter } from 'react-message-context';
import { useAppState } from '../context/appContext';

export const useFormattedClockTime = () => {
  const t = useMessageGetter('time');
  const { language } = useAppState();
  dayjs.locale(language ?? 'fi');

  const formatClockTime = (time: string | undefined) =>
    time ? `${t('clock')} ${dayjs(time, 'HH:mm').format('HH.mm')}` : '';

  return { formatClockTime };
};
